import modal from './modal.vue'
export default {
  install: function(Vue) {
    Vue.component('modal', modal)
  }
}



// WEBPACK FOOTER //
// ./src/components/modal/index.js